import { render, staticRenderFns } from "./TaskTemplateDetailEdit.vue?vue&type=template&id=245be4b2&"
import script from "./TaskTemplateDetailEdit.vue?vue&type=script&lang=js&"
export * from "./TaskTemplateDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports